import React from 'react'
import { PageHeader, PageSection } from 'components/layout'
import { InjectedContentfulProps, withContentful } from 'components/vendor/Contentful/withContentful'
import { COLORS, CONTENTFUL_KEYS, ROUTES } from 'parameters/index'
import Link from 'next/link'
import { ServiceItem } from 'experiences/home/FinancialServices/ServiceItem'
import styled from '@emotion/styled'

const Insurance = ({ getValue }: InjectedContentfulProps): JSX.Element => {
	return (
		<>
			<PageHeader
				title={<h1>{getValue(CONTENTFUL_KEYS.INSURANCE.TITLE)}</h1>}
				description={getValue(CONTENTFUL_KEYS.INSURANCE.DESCRIPTION)}
				className="productHeader"
			/>
			<PageSection background={COLORS.SMOKE_WHITE} divider={false}>
				<LoansText>{getValue(CONTENTFUL_KEYS.INSURANCE.CONTENT.TITLE)}</LoansText>
				<LoansItems>
					<ServiceItem
						name={getValue(CONTENTFUL_KEYS.INSURANCE.ITEM_ONE.TEXT)}
						icon={getValue(CONTENTFUL_KEYS.INSURANCE.ITEM_ONE.IMAGE).url}
						href={ROUTES.NATIVE_LIFE_INSURANCE}
					/>
					<ServiceItem
						name={getValue(CONTENTFUL_KEYS.INSURANCE.ITEM_TWO.TEXT)}
						icon={getValue(CONTENTFUL_KEYS.INSURANCE.ITEM_TWO.IMAGE).url}
						href={ROUTES.AUTO_INSURANCE}
						external
					/>
				</LoansItems>
				<LoansBottomText>
					Not looking for an insurance policy,{' '}
					<Link href="/" passHref>
						see all our products
					</Link>
				</LoansBottomText>
			</PageSection>
		</>
	)
}

const LoansText = styled.h2`
	text-align: center;
	margin: 0 0 42px 0;
`

const LoansBottomText = styled.p`
	text-align: center;
	margin: 0 0 42px 0;
	font-size: 20px;
	color: ${COLORS.BLACK};
`

const LoansItems = styled.div`
	display: flex;
	justify-content: center;
	gap: 24px;
	align-items: center;
	margin: 0 auto;
	margin-bottom: 24px;
	@media only screen and (max-width: 560px) {
		flex-direction: column;
		a {
			width: 100%;
		}
	}
`

export default withContentful(Insurance)
